import React, { useState } from 'react'
import { connectPagination } from 'react-instantsearch-dom'
import Pagination from '@bit/atd.web.pagination'

type PropTypes = {
  currentRefinement: number
  nbPages: number
  refine: (page: number) => void
}

const AlgoliaPagination = (props: PropTypes) => {
  const { currentRefinement, refine, nbPages } = props
  const [defaultPage] = useState(currentRefinement)
  const onPageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    refine(page)
  }
  if (nbPages < 2) return null
  return (
    <Pagination
      onChange={onPageChange}
      currentPage={currentRefinement}
      defaultPage={defaultPage}
      setCurrentPage={() => {
        // do nothing
      }}
      count={nbPages}
    />
  )
}

export default connectPagination(AlgoliaPagination)
